import { App, Button, Card, DatePicker, Flex, Form, Input, InputNumber, Radio, Select, Space, Table, Upload, UploadProps } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import LoadingOverlay from 'react-loading-overlay-ts';
import CkEditor from "../ckeditor/ckEditor";
import TextArea from 'antd/es/input/TextArea';
import { SentResultInterface } from '../../models/IBudgetRequest';
import { formatNumber, isDateSelected, isNull, monthcolumn, periodToString } from "../functionLater";
import { UploadOutlined } from '@ant-design/icons';
import { Editor } from 'ckeditor5';
import { useParams } from 'react-router-dom';
import { AboutResearchInterface } from '../../models/IAboutResearch';
import { BudgetDataInterface } from '../../models/IBudgetData';
import { OutputInterface } from '../../models/Result';
import axios from 'axios';

export function CompletionReport(){
    const [isActive,setisActive]= useState(false);
    const [isHistory,setisHistory]= useState(false);

    const SentResult = [
        {
            ResultMain:'ส่งมอบผลผลิตที่ระบุ และต้นฉบับรายงานการวิจัยจำนวน ๒  เล่ม พร้อมแฟลชไดร์ฟ จำนวน ๒ อัน ที่สมบูรณ์ และหลักฐานการตีพิมพ์เผยแพร่ผลงานวิจัย  แก่ผู้ให้ทุน ตามเงื่อนไขที่ผู้ให้ทุนกำหนด',
            subdata:[
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับนานาชาติ'},
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับ TCI กลุ่มที่ 1'},
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับ TCI กลุ่มที่ 2'},
            ]
        },{
            ResultMain:'ส่งมอบผลผลิตที่ระบุ และเอกสารหลักฐานการตีพิมพ์เผยแพร่ผลงานวิจัย  จำนวน  ๑  ชุด  แก่ผู้ให้ทุน ตามเงื่อนไขที่ผู้ให้ทุนกำหนด',
            subdata:[
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับนานาชาติ'},
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับ TCI กลุ่มที่ 1'},
                {RemainSub:'ตีพิมพ์เผยแพร่ผลงานวิจัยและนวัตกรรมในวารสารระดับ TCI กลุ่มที่ 2'},
            ]
        },{
            ResultMain:'กรณีงานวิจัยหลักสูตร ส่งมอบผลผลิตที่ระบุ และส่งต้นฉบับรายงานการวิจัย จำนวน ๑  เล่ม พร้อมแฟลชไดร์ฟ จำนวน ๑ อัน ที่สมบูรณ์  แก่ผู้ให้ทุน ตามเงื่อนไขที่ผู้ให้ทุนกำหนด',
        
        },
    ]
    
    const [SelectedResult,setSelectedResult] = useState('')
    const [SelectedSubResult,setSelectedSubResult] = useState('')


    const {ROCKEditors,CKEditors,getHTML} = CkEditor();


    const { project_id } = useParams();

    const [form] = Form.useForm();

    const [Output,setOutput] = useState<OutputInterface[]>([])
    const [OutputProgress,setOutputProgress] = useState<OutputInterface[]>([])

    const [selectedmonth,setselectedmonth] = useState(99)
    const [endmonth,setEndMonth] = useState(99)
    const [selectedyear,setselectedyear] = useState(9999)

    const [DataFirst,setDataFirst] = useState<AboutResearchInterface[]>([]);

    const [compensationsum,setCompensationSum] = useState(0)
    const [compensationMonetry,setCompensationMonetrySum] = useState(0)
    const [compensationPrepared,setCompensationPreparedSum] = useState(0)
    const [compensationIndirect,setCompensationIndirectSum] = useState(0)
    const [outcomesum,setOutcomeSum] = useState(0)
    const [outcomeMonetry,setOutcomeMonetrySum] = useState(0)
    const [outcomePrepared,setOutcomePreparedSum] = useState(0)
    const [outcomeIndirect,setOutcomeIndirectSum] = useState(0)

    const [itemsum,setItemnSum] = useState(0)
    const [itemMonetry,setItemMonetrySum] = useState(0)
    const [itemPrepared,setItemPreparedSum] = useState(0)
    const [itemIndirect,setItemIndirectSum] = useState(0)
    const [compensationItems, setCompensationItems] = useState<BudgetDataInterface[]>([]);
    const [OutcomeItems, setOutcomeItems] = useState<BudgetDataInterface[]>([]);

    const {message} = App.useApp();
    
    const [Keys, setExpandedRowKeys] = useState<string[]>([]);

  
    const [ItemCost, setItemCost] = useState<BudgetDataInterface[]>([]);

    const [ProgressSummary,setProgressSummary] = useState("")


    const ProgressSummaryRef = useRef<Editor | null>(null);
    const ProblemsAndObstacleRef = useRef<Editor | null>(null);
    const SuggestionRef = useRef<Editor | null>(null);

    const BudgetTypeCol = [
        {
          id: 1,
          detail: 'หมวดค่าตอบแทน',
          category:'compensation',
          sum:compensationsum,
          MonetrySum:compensationMonetry,
          PreparedSum:compensationPrepared,
          IndirectSum:compensationIndirect
        },
        {
          id: 2,
          detail: 'หมวดค่าใช้จ่าย',
          category:'outcome',
          sum:outcomesum,
          MonetrySum:outcomeMonetry,
          PreparedSum:outcomePrepared,
          IndirectSum:outcomeIndirect
        },
        {
            id: 3,
            detail: 'หมวดค่าวัสดุ และอุปกรณ์',
            category:'itemexpense',
            sum:itemsum,
            MonetrySum:itemMonetry,
            PreparedSum:itemPrepared,
            IndirectSum:itemIndirect
          },
          {
            id: 4,
            detail: 'รวม',
            category:'',
            sum:Number(itemsum)+Number(outcomesum)+Number(compensationsum),
            MonetrySum:Number(compensationMonetry)+Number(outcomeMonetry)+Number(itemMonetry),
            PreparedSum:Number(compensationPrepared)+Number(outcomePrepared)+Number(itemPrepared),
            IndirectSum:Number(compensationIndirect)+Number(outcomeIndirect)+Number(itemIndirect)
          }
      ];
      const handleExpand = (expanded: boolean, record: any) => {
        
        if (expanded) {
            console.log(record.id)
            setExpandedRowKeys([record.id]); // Expand only the clicked row
        } else {
            setExpandedRowKeys([]); // Collapse all rows
        }
    };

    const props: UploadProps = {
        name: 'file',
        action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
        headers: {
          authorization: 'authorization-text',
        },
        onChange(info) {
          if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
          }
          if (info.file.status === 'done') {
            message.success(`${info.file.name} file uploaded successfully`);
          } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
          }
        },
      };
    
    const handleProgressSummaryEditorChange = () =>{
        setProgressSummary(getHTML(ProgressSummaryRef))
    }
   
    const expandedRowRender = (record: any) => {
        let dataSource:  any[] | undefined = [];
  
        if (record.category === 'compensation') {
          dataSource = compensationItems;
        } else if (record.category === 'outcome') {
          dataSource = OutcomeItems;
        } else if (record.category === 'itemexpense') {
          dataSource = ItemCost;
        }
      
        return <>
        <Table
          columns={[
              {
                  title:'',
                  dataIndex: 'BudgetDetail',
                  key: 'BudgetDetail',
                  width: 450,
              },
              {
                  title:'',
                  dataIndex: 'Budget',
                  key: 'Budget',
                  width: 250,
                  render: (_, record) => (
                    <Flex justify="center">{formatNumber(record.Budget)}</Flex>
                  ),},
              {
                  title:'',
                  dataIndex: 'BudgetDetail',
                  key: 'BudgetDetail',
                  width: 250,
                  render: (_, record) => (
                      <>
                          <Form.Item>
                              <Input/>
                          </Form.Item>
                      </>
                    ),
              },
              {title:'หมายเหตุ',
                  render: (_, record) => (
                      <>
                          <Form.Item>
                              <Input/>
                          </Form.Item>
                      </>
                    ),}
          ]}
          showHeader={false} 
          pagination={false}
          dataSource={dataSource}/>
        </>
      }

      const getData = async() =>{
        await axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response=>{
            setDataFirst(response.data.main)

            if(response.data.main[0].period){
                const dataperiod = JSON.parse(response.data.main[0].period)
                const datamonth = dataperiod[0].split('-')
                const datamonth2 = dataperiod[1].split('-')
                setselectedmonth(Number(datamonth[1]))
                setEndMonth(Number(datamonth2[1]))
                setselectedyear(Number(datamonth[0]))
            }

            if(response.data.compensation.length!=0||response.data.outcome.length!=0||response.data.itemexpense.length!=0){
                setCompensationItems(response.data.compensation)
                const totalCompensation = response.data.compensation.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setCompensationSum(totalCompensation)
                const totalMonetryCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationMonetrySum(totalMonetryCompensationBudget)
                const totalPreparedCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationPreparedSum(totalPreparedCompensationBudget)
                const totalIndirectCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationIndirectSum(totalIndirectCompensationBudget)
            
                const totalOutcome = response.data.outcome.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setOutcomeSum(totalOutcome)
                setOutcomeItems(response.data.outcome)
                const totalMonetryOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeMonetrySum(totalMonetryOutcomeBudget)
                const totalPreparedOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomePreparedSum(totalPreparedOutcomeBudget)
                const totalIndirectdOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeIndirectSum(totalIndirectdOutcomeBudget)

                const totalItem = response.data.itemexpense.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setItemnSum(totalItem)
                setItemCost(response.data.itemexpense)
                const totalMonetryItemBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemMonetrySum(totalMonetryItemBudget)
                const totalPreparedItemeBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemPreparedSum(totalPreparedItemeBudget)
                const itemMonetrySum = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemIndirectSum(itemMonetrySum)
                
            }

            if(response.data.main[0].output&&response.data.main[0].outcome&&response.data.main[0].impacts){
                setOutput(JSON.parse(response.data.main[0].output))
              }
            
        })
    }
    
      useEffect(() =>{
        getData();
        },[])
    return (
        <>
        
         <LoadingOverlay
                active={isActive}
                spinner
                text='กำลังโหลดข้อมูล'
            >
                 <h1 className="text-3xl font-semibold leading-relaxed">ฟอร์มยื่นคำขอปิดโครงการวิจัย</h1>
                 <br/>
                 <hr/>
                 <br/>
                 <Form
                    form={form}
                    autoComplete="off"
                    layout='vertical'>
                <h1 className="text-3xl font-semibold leading-relaxed">รายงานความก้าวหน้าโครงงานวิจัย</h1>
                <br/>
                <hr/>
                <br/>
                {
                    isHistory&&
                    <>
                         <h2 className="text-2xl font-bold leading-relaxed"  style={{display: "flex"}} >ประวัติการยื่นขอปิดโครงการ</h2>
                            <Card style={{marginLeft:'5vw'}}>
                                <p className="font-semibold leading-relaxed" style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>ประวัติการยื่นรายงานครั้งที่&nbsp;&nbsp;<Select style={{width:'10vw'}}/></p>
                                <p></p>
                            </Card>
                            <br/>
                    </>
                }
                <h2 className="text-2xl font-bold leading-relaxed"  style={{display: "flex"}} >ฟอร์มการยื่นขอปิดโครงการ</h2>
               
                    <p className="font-bold leading-relaxed" >รายงานผลการดำเนินการวิจัย และการวิเคราะห์ผลการวิจัย</p>
                        <Table
                            columns={[
                                {
                                    title:'แผนการดำเนินงาน',
                                    dataIndex:'ActivityName',
                                    fixed: 'left',  
                                    width: 200,  
                                    className: 'fixed-column'
                                },
                                {
                                  title:'ระยะเวลาที่ทำกิจกรรม',
                                 children:monthcolumn(selectedmonth,endmonth,DataFirst?.[0]?.period? JSON.parse(DataFirst?.[0]?.period): [])

                                },
                               {
                                    title:'ความสำเร็จต่อโครงการ',
                                    dataIndex:'ActivityRatio',
                                    fixed: 'right',  
                                    width: 200, 
                                    className: 'fixed-column',
                                    render: (_, record,index) => (
                                        <>
                                            <Form.Item name={['ActivityInfo', index,'ProgressionPercent']}>
                                                <InputNumber/>
                                            </Form.Item>
                                        </>
                                    )
                                },{
                                    title:'หมายเหตุ',
                                    fixed: 'right',  
                                    width: 200, 
                                    className: 'fixed-column',
                                    render: (_, record,index) => (
                                        <>
                                            <Form.Item name={['ActivityInfo', index,'note']}>
                                                <TextArea autoSize={{ minRows: 3, maxRows: 5 }}/>
                                            </Form.Item>
                                        </>
                                    )
                                },
                            ]}
                            dataSource={DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []}
                            scroll={{ x: 'max-content' }}
                            pagination={false}
                        />
                    <p className="font-bold leading-relaxed" >รายละเอียดของขั้นตอนการดำเนินงานจริงตามแผนงาน (ช่วงรายงานผล) </p>
                    <Form.Item>
                        <Table
                            columns={[
                                {
                                    title:'วัตถุประสงค์', 
                                    dataIndex:'ActivityName',
                                    width:'20vw'
                                },
                                {
                                    title:'สิ่งที่ดำเนินการ',
                                    render: (_, record,index) => (
                                        <>
                                            <Form.Item name={['ActivityInfo', index,'PastProgress']}>
                                                <TextArea placeholder='กรอกข้อมูลที่นี่' autoSize={{ minRows: 3, maxRows: 5 }}/>
                                            </Form.Item>
                                        </>
                                    )
                                },
                                {
                                    title:'สิ่งที่จะดำเนินการ',
                                    render: (_, record,index) => (
                                        <>
                                            <Form.Item name={['Objective', index,'FuturePlan']}>
                                                <TextArea placeholder='กรอกข้อมูลที่นี่' autoSize={{ minRows: 3, maxRows: 5 }}/>
                                            </Form.Item>
                                        </>
                                    )
                                }
                                
                            ]}
                            pagination={false}
                            dataSource={DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []}
                            />
                    </Form.Item>
                    <p className="font-semibold">สรุปผลการดำเนินงาน</p>
                    <CKEditors
                        myRef={ProgressSummaryRef}
                        htmlBox={ProgressSummary}
                        onBlur={handleProgressSummaryEditorChange}
                        toolstate={true}
                        />
                    <Form.Item label={<p className="font-semibold">ปัญหาและอุปสรรค</p>}>
                        <CKEditors/>
                    </Form.Item>
                    <Form.Item label={<p className="font-semibold">คำแนะนำและข้อมูลเพิ่มเติมอื่นๆ (ถ้ามี) </p>}>
                        <CKEditors/>
                    </Form.Item>
                    <p className="font-semibold">รายจ่ายที่เกิดขึ้นจริง</p>
                        <Table
                            rowKey="id"
                            columns={[
                                {
                                    title:'หมวดรายการงบประมาณ',
                                    dataIndex:'detail',
                                    width: 450,
                                },
                                {
                                    title:'งบประมาณ (บาท)',
                                    width: 500,
                                    children:[
                                        {
                                            title:'งบประมาณที่ได้รับ',
                                            width: 250,
                                            render: (_, record) => (
                                              <Flex justify="center">{formatNumber(record.MonetrySum+record.PreparedSum+record.IndirectSum)}</Flex>
                                            ),},
                                        {
                                            title:'จำนวนเงินที่ใช้ไป',
                                            width: 250,
                                            render: (_, record) => (
                                              <>
                                                <p>ยังไม่มีข้อมูล</p>
                                              </>
                                        )},
                                    ]
                                },
                                {title:'หมายเหตุ'},
                            ]}
                            expandable={{
                                expandedRowRender,
                                expandedRowKeys: Keys,
                                onExpand: handleExpand,
                                rowExpandable: (record) => {
                                    if (record.category === 'compensation') return compensationItems.length > 0;
                                    if (record.category === 'outcome') return OutcomeItems.length > 0;
                                    if (record.category === 'itemexpense') return ItemCost.length > 0;
                                    return false;
                                  },
                            }}
                            scroll={{ x: 'max-content' }}
                            dataSource={BudgetTypeCol}
                            pagination={false}
                            />
                    
                    <p className="font-semibold">ผลผลิตที่คาดว่าจะได้รับ</p>
                    <Table
                        columns={[
                            {
                                title:'ผลผลิต',
                                dataIndex:'Output_name',
                                fixed: 'left',  
                                width: 200,  
                                className: 'fixed-column'
                            },{
                                title: 'จำนวนนำส่ง/หน่วยนับ',
                                dataIndex:'Output_amount',
                                key: 'Output_amount',
                                render: (_, record) => (
                                    <>
                                        <p>{record.Output_amount} {record.Output_unit}</p>
                                    </>
                                  ),
                            },{
                                title:'รายละเอียดผลผลิต',
                                render: (_, record) => (
                                    <>
                                        <Form.Item>
                                            <TextArea placeholder='กรอกข้อมูลที่นี่' autoSize={{ maxRows: 5 }}/>
                                        </Form.Item>
                                    </>
                                  ),
                            },{
                                title:'ปีที่นำส่งผลผลิต',
                                render: (_, record) => (
                                    <>
                                        <Form.Item>
                                            <DatePicker picker="year" placeholder=''/>
                                        </Form.Item>
                                    </>
                                  ),
                            },{
                                title:'เปอร์เซ็นความก้าวหน้าการดำเนินงาน',
                                render: (_, record) => (
                                    <>
                                        <Flex justify='center'>
                                        <Form.Item>
                                            <InputNumber/>
                                        </Form.Item></Flex>
                                    </>
                                  ),
                            },{
                                title:'ผลผลิตที่เกิดขึ้นจริง',
                                render: (_, record) => (
                                    <>
                                        <Form.Item>
                                            <TextArea placeholder='กรอกข้อมูลที่นี่' autoSize={{ maxRows: 5 }}/>
                                        </Form.Item>
                                    </>
                                  ),
                            },{
                                title:'หลักฐาน/เอกสารประกอบ',
                                render: (_, record) => (
                                    <>
                                        <Form.Item>
                                            <TextArea placeholder='กรอกข้อมูลที่นี่' autoSize={{ maxRows: 5 }}/>
                                        </Form.Item>
                                    </>
                                  ),
                              
                            },{
                                title:'ไฟล์แนบ',
                                width: 200,
                                render: (_, record) => (
                                    <>
                                        <Flex justify='center'>
                                            <Upload {...props}>
                                                <Button icon={<UploadOutlined />}>อัพโหลดไฟล์</Button>
                                            </Upload>
                                        </Flex>
                                        <br/>
                                        <Flex justify='center'>
                                            <Button>ดูข้อมูลไฟล์ที่ดาวน์โหลด</Button>
                                        </Flex>
                                    </>
                                  ), 
                            }
                        ]}
                        pagination={false}
                        scroll={{ x: 'max-content' }}
                        dataSource={Output}/>
                    
                    <Form.Item label={<p style={{fontWeight:'bold'}}>เมื่อผู้รับทุนทำการวิจัยเสร็จสมบูรณ์ตามระยะเวลาที่กำหนด ผู้รับทุนสามารถปิดโครงการวิจัยได้  3  กรณี  ดังนี้</p>}>
                    <Space direction="vertical">
                        <Radio.Group  className='font-normal' onChange={(e) => setSelectedResult(e.target.value)} value={SelectedResult}>
                        <Space direction="vertical">
                            {SentResult.map((item)=>(
                                <React.Fragment key={item.ResultMain}>
                                    <Space direction="vertical">
                                        <Radio value={item.ResultMain}>{item.ResultMain}</Radio>
                                        {(SelectedResult == item.ResultMain && SelectedResult != 'กรณีงานวิจัยหลักสูตร ส่งมอบผลผลิตที่ระบุ และส่งต้นฉบับรายงานการวิจัย จำนวน ๑ เล่ม พร้อมแฟลชไดร์ฟ จำนวน ๑ อัน ที่สมบูรณ์ แก่ผู้ให้ทุน ตามเงื่อนไขที่ผู้ให้ทุนกำหนด') && (
                                            <>
                                            
                                                <>
                                                <Radio.Group onChange={(e) => setSelectedSubResult(e.target.value)} style={{ marginLeft: '40px' }} value={SelectedSubResult}> 
                                                <Space direction="vertical">
                                                    {
                                                        item.subdata?.map((subtype)=>(
                                                        <>
                                                            <Radio key={subtype.RemainSub} value={subtype.RemainSub}>{subtype.RemainSub}</Radio>
                                                        </>)
                                                    )
                                                    }
                                                </Space>
                                                </Radio.Group>
                                                </>
                                                
                                            </>
                                        )}
                                    </Space>
                                </React.Fragment>
                            ))}
                        </Space>
                        </Radio.Group>
                    </Space>
                    </Form.Item>
                    <Flex justify='center'>
                        <Button>ยื่นคำขอปิดโครงการ</Button>
                    </Flex>
                </Form>
            </LoadingOverlay>
        </>
    )
}